/** 获取传入节点的整体宽度，包含margin、border、padding、container */
function calculateNodeTotalWidth(node, ignoreMargin = false) {
    if (!node)
        return 0;
    const hidden = window.getComputedStyle(node).display === 'none';
    if (hidden)
        return 0;
    const exceptMarginWidth = node.getBoundingClientRect().width;
    if (ignoreMargin)
        return exceptMarginWidth;
    const marginLeftWidth = parseFloat(window.getComputedStyle(node).marginLeft || '0') + parseFloat(window.getComputedStyle(node).marginRight || '0');
    return exceptMarginWidth + marginLeftWidth;
}

export { calculateNodeTotalWidth };
//# sourceMappingURL=node-util.js.map
